import axiosInstance from "@/api/axiosInstance";
import { UpdateEventSessionAttendanceRequest } from "./types";

export async function updateEventSessionAttendance(
  attendanceId: number,
  data: UpdateEventSessionAttendanceRequest,
): Promise<void> {
  await axiosInstance.patch(
    `/api/private/event-session-attendance/${attendanceId}`,
    data,
  );
}
